/**
 * Telemetria de visitas — port HUMANIZE-style.
 *
 * PR #268: sessionId + pingVisita(path) basic
 * PR #271: enrichment — referrer, language, screen dimensions + sendBeacon +
 *          anti-double-fire 5s + uso de navigator.sendBeacon quando disponível.
 *
 * Privacidade:
 * - sessionId é UUID gerado no cliente, sem PII
 * - IP só vem do request — backend hashea SHA-256(IP::UA::salt)[:16]
 * - Anti-double-fire: pageview a <5s do anterior é ignorado (SPA hash mudança)
 */

const SESSION_KEY = "acordei_session_id_v1";
const LAST_TRACK_KEY = "acordei_last_track";
const DEDUP_WINDOW_MS = 5000;

function gerarSessionId(): string {
  // crypto.randomUUID disponível em navegadores modernos
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID().replace(/-/g, "");
  }
  // Fallback simples
  return (
    Date.now().toString(36) +
    Math.random().toString(36).slice(2, 10) +
    Math.random().toString(36).slice(2, 10)
  );
}

export function obterSessionId(): string {
  if (typeof window === "undefined") return "ssr";
  try {
    const existente = window.localStorage.getItem(SESSION_KEY);
    if (existente && existente.length >= 8) return existente;
    const novo = gerarSessionId();
    window.localStorage.setItem(SESSION_KEY, novo);
    return novo;
  } catch {
    // localStorage bloqueado (incognito/cookies off) — gera ID volátil
    return gerarSessionId();
  }
}

export async function pingVisita(path: string): Promise<void> {
  // PR #271: Anti-double-fire (SPA hash mudança ou reload em <5s não conta)
  try {
    if (typeof sessionStorage !== "undefined") {
      const now = Date.now();
      const last = Number(sessionStorage.getItem(LAST_TRACK_KEY) || 0);
      if (now - last < DEDUP_WINDOW_MS) return;
      sessionStorage.setItem(LAST_TRACK_KEY, String(now));
    }
  } catch {
    // ignora — segue o ping
  }

  // Fire-and-forget — falhas não afetam UX
  try {
    const sessionId = obterSessionId();
    const referrer =
      typeof document !== "undefined" ? document.referrer || null : null;
    // PR #271 enrichment: language + screen dimensions
    const lang =
      typeof navigator !== "undefined" ? (navigator.language || "").slice(0, 10) : null;
    const sw = typeof screen !== "undefined" ? screen.width || 0 : 0;
    const sh = typeof screen !== "undefined" ? screen.height || 0 : 0;

    const payload = { sessionId, path, referrer, lang, sw, sh };
    const body = JSON.stringify(payload);

    // Prefere sendBeacon (sobrevive page unload) — fallback fetch keepalive
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon(
        "/api/v1/visits/ping",
        new Blob([body], { type: "application/json" }),
      );
    } else {
      await fetch("/api/v1/visits/ping", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      });
    }
  } catch {
    // Silencia — telemetria nunca quebra UX
  }
}
